export default __webpack_public_path__ + "76f5971e78f4c754c1e5f8b7ca4e6bfa.png";